<template>
	<div class="panel_settlement">
		<div style="padding-top:7px;">
			<span class="priceItem">
				<span class="label">总计：</span>
				<span class="price">￥{{money}}</span>
			</span>
		</div>
		<div>
			<span class="priceItem" style="margin-right: 20px;">
				<span class="label">应付金额：</span>
				<span class="price" style="color:#FF2F2F;">￥{{money}}</span>
			</span>
			<el-button style="width:80px;" type="warning" size="small" plain @click="openBeizhu">备注</el-button>
			<el-button style="width:100px;" type="warning" size="small" plain @click="submitOrder">生成订单</el-button>
			<el-button style="width:80px;" type="warning" size="small" @click="submitOrderAndSettlement">结算</el-button>
		</div>
		<!-- 备注弹窗 -->
		<div v-if="drawerRemark_state">
			<drawerRemark :type="'xizaokaUpdate'" @submit="submit_drawerRemark"></drawerRemark>
		</div>
		<!-- 结算 -->
		<div v-if="dialogSettlement_state">
			<dialogSettlement :type="'order'" :orderId="curOrder._id" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
	</div>
</template>
<script>
	import drawerRemark from "../drawer/remark.vue"
	import dialogSettlement from "../../../../components/dialog_settlement.vue"
	export default {
		components:{drawerRemark,dialogSettlement},
		data(){
			return{
				// 备注
				drawerRemark_state:false,
				// 是否直接结算
				directSettlement:false,
				// 结算
				dialogSettlement_state:false,
				curOrder:{},
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
			curRow(){
				return this.$store.state.xizaoka.curRow;
			},
			goodsItem(){
				return this.$store.state.xizaokaUpdate.addParams.serviceItem;
			},
			skuItem(){
				return this.$store.state.xizaokaUpdate.addParams.goodsItem;
			},
			times(){
				return this.$store.state.xizaokaUpdate.times;
			},
			saleManIdList(){
				return this.$store.state.xizaokaUpdate.saleManIdList;
			},
			money(){
				return this.$store.state.xizaokaUpdate.money;
			},
			remark(){
				return this.$store.state.xizaokaUpdate.remark;
			},
		},
		mounted(){
		},
		methods:{
			submitOrderAndSettlement(){
				this.directSettlement = true;
				this.submitOrder();
			},
			// 创建订单
			submitOrder(){
				if(!this.skuItem.detail_id){
					this.$message({
						message: '请选择新的洗美卡',
						type: 'error'
					});
					return ;
				}
				if(this.times!=='all'&&this.times!=='also'){
					this.$message({
						message: '请选择升级次数',
						type: 'error'
					});
					return ;
				}
				if(this.$public.isNull(this.saleManIdList)){
					this.$message({
						message: '请选择销售人员',
						type: 'error'
					});
					return ;
				}
				let salesMans = []
				for(let i=0;i<this.saleManIdList.length;i++){
					let arr = this.saleManIdList[i].split(',')
					salesMans.push({"userId": arr[0],"userName": arr[1]})
				}
				let oldCard = {
					"cardNumber": this.curRow.card_number,  // 消费卡编号
					"surplusCount": this.curRow.surplus_count,  // 剩余次数
					"unitPrice": this.curRow.unit_price,  // 单价
				}
				let newCard = {
					"goodsId": this.goodsItem.virtualId,  // 新卡的产品id
					"goodsName": this.goodsItem.title,  // 新卡的名字
					"categoryId": this.goodsItem.category_info._id,  // 当前分类id
					"categoryName": this.goodsItem.category_info.name,  // 当前分类名称
					"skuId": this.skuItem.detail_id,  // 规格id
					"skuValue": this.skuItem.service_objectName,  // 规格名字
					"unit": "",  // 商品单位
					"originalPrice": this.skuItem.price,  // 原价
					"price": this.skuItem.price,  // 实际售价
					"totalCount": this.goodsItem.total_count,  // 可使用总次数
				}
				let params = {
					"memberId": this.userInfo._id,
					"memberName": this.userInfo.basic_info.nick_name,
					"memberMobile": this.userInfo.basic_info.user_mobile,
					"oldCard": oldCard,
					"newCard": newCard,
					"count": this.times==='also'?this.curRow.surplus_count:this.goodsItem.total_count,  // 升级次数
					"salesMans": salesMans,
					"remark": this.remark
				}
				console.log(params)
				let loading = this.$loading()
				this.$http.post('/api/Order/WashBathCardUpgradeOrder', params).then(res => {
					loading.close();
					if (res.code == 0) {
						if(this.directSettlement){
							this.curOrder = res.data;
							this.dialogSettlement_state = true;
						}else{
							this.$store.commit('xizaoka/set_type','list')
						}
					}
				})
			},
			// 结算
			dialogSettlementSubmit(a){
				this.dialogSettlement_state = false;
				if(a=='cancel'){
					console.log(a)
				}else if(a=='fail'){
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				}else if(a=='success'){
					this.$message({
						message: '结算成功',
						type: 'success'
					});
					this.$store.dispatch("mendian/getUserInfo",this.userInfo._id)
				}
				this.$store.commit('xizaoka/set_type','list')
			},
			// 备注
			openBeizhu(){
				this.drawerRemark_state=true;
			},
			submit_drawerRemark(){
				this.drawerRemark_state=false;
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_settlement{
	display: flex;
	justify-content: space-between;
	padding:10px 20px;
	background-color: #fff;
	box-shadow: 0 -3px 3px 0px #f5f5f5;
	.priceItem{
		display: inline-flex;align-items: center;
		margin-right: 40px;
		.label{
			font-size: 14px;color:$fontColor;
		}
		.price{
			font-size: 20px;color:$fontColor;
		}
	}
}
</style>
